// @ts-nocheck
import VueI18n from 'vue-i18n'
import Vue from 'vue'
import { getLang, setLang } from '@/lib/storage'
import { parseUrl } from '@/lib/util'
import zh from './lang/zh'
import en from './lang/en'

Vue.use(VueI18n)

const messages = {
  en,
  zh
}

const getLanguage = () => {
  let lang = getLang()
  if (!lang) {
    lang = parseUrl('lang')
    lang = lang || (navigator.language || navigator.browserLanguage).toLowerCase()
  }
  const locales = Object.keys(messages)
  if (locales.indexOf(lang) > -1) {
    return lang
  }
  return 'zh'
}

const locale = getLanguage()
document.title = messages[locale].title
setLang(locale)

const i18n = new VueI18n({
  locale,
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js